// import React, { useState, useEffect } from "react";
// import * as XLSX from "xlsx";
// import { initializeApp } from "firebase/app";
// import {
//   getFirestore,
//   collection,
//   addDoc,
//   onSnapshot,
//   query,
//   orderBy,
//   deleteDoc,
//   doc,
//   updateDoc,
//   Timestamp,
// } from "firebase/firestore";
// import {
//   Plus,
//   Trash2,
//   Moon,
//   Sun,
//   Edit3,
//   BrainCircuit,
//   AlertTriangle,
//   Send,
//   Download,
// } from "lucide-react";

// // Firebase Config
// const firebaseConfig = {
//   apiKey: "AIzaSyBfZDqL3oynap-pKx-sicb_Fybhn-NIFlQ",
//   authDomain: "dailyplanner-c0691.firebaseapp.com",
//   projectId: "dailyplanner-c0691",
//   storageBucket: "dailyplanner-c0691.firebasestorage.app",
//   messagingSenderId: "942859622871",
//   appId: "1:942859622871:web:276daf458d4ff7d0355392",
// };

// const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);

// const TELEGRAM_BOT_TOKEN = "8685912259:AAElu44Uz8PHaQbrccqhsLB87dY4W0VlHQo";
// const TELEGRAM_CHAT_ID = "5587626734";

// const VPNTrackerApp = () => {
//   const [entries, setEntries] = useState([]);
//   const [isDark, setIsDark] = useState(true);

//   const [customerName, setCustomerName] = useState("");
//   const [vpnKey, setVpnKey] = useState("");
//   const [amount, setAmount] = useState("");
//   const [expense, setExpense] = useState("0");
//   const [duration, setDuration] = useState(1);
//   const [saleDate, setSaleDate] = useState(
//     new Date().toISOString().split("T")[0],
//   );
//   const [expiryDate, setExpiryDate] = useState("");
//   const [editId, setEditId] = useState(null);

//   const calculateExpiry = (dateString, months) => {
//     const date = new Date(dateString);
//     date.setDate(date.getDate() + months * 30);
//     return date.toISOString().split("T")[0];
//   };

//   useEffect(() => {
//     setExpiryDate(calculateExpiry(saleDate, duration));
//   }, [saleDate, duration]);

//   useEffect(() => {
//     const q = query(collection(db, "sales"), orderBy("saleDate", "desc"));

//     const unsubscribe = onSnapshot(q, (snapshot) => {
//       const rawData = snapshot.docs.map((doc) => ({
//         ...doc.data(),
//         id: doc.id,
//       }));

//       const sortedData = rawData.sort((a, b) => {
//         if (a.saleDate === b.saleDate) {
//           const timeA = a.createdAt?.toMillis() || 0;
//           const timeB = b.createdAt?.toMillis() || 0;
//           return timeB - timeA;
//         }
//         return 0;
//       });

//       setEntries([...sortedData]);
//     });
//     return () => unsubscribe();
//   }, []);

//   const exportToExcel = () => {
//     if (entries.length === 0) return alert("ထုတ်ရန် Data မရှိပါ");
//     const dataToExport = entries.map((e) => ({
//       "Sale Date": e.saleDate,
//       Customer: e.customer,
//       "VPN Key": e.key,
//       Duration: e.duration + " Months",
//       Price: e.amount,
//       Profit: Number(e.amount) - Number(e.expense || 0),
//       Expiry: e.expiryDate,
//     }));
//     const ws = XLSX.utils.json_to_sheet(dataToExport);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Sales");
//     XLSX.writeFile(wb, `VPN_Sales_Export.xlsx`);
//   };

//   const sendTelegramMsg = async (text) => {
//     const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage?chat_id=${TELEGRAM_CHAT_ID}&text=${encodeURIComponent(text)}&parse_mode=HTML`;
//     try {
//       await fetch(url);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!customerName || !amount) return alert("အချက်အလက် အပြည့်အစုံထည့်ပါ");
//     const profit = Number(amount) - Number(expense);
//     const data = {
//       customer: customerName,
//       key: vpnKey || "-",
//       amount: Number(amount),
//       expense: Number(expense),
//       duration: duration,
//       saleDate,
//       expiryDate,
//       updatedAt: Timestamp.now(),
//     };
//     try {
//       if (editId) {
//         await updateDoc(doc(db, "sales", editId), data);
//         setEditId(null);
//       } else {
//         await addDoc(collection(db, "sales"), {
//           ...data,
//           createdAt: Timestamp.now(),
//         });
//       }
//       sendTelegramMsg(
//         `<b> Success!</b>\n👤: ${customerName}\n💰 Profit: ${profit} Ks`,
//       );
//       setCustomerName("");
//       setVpnKey("");
//       setAmount("");
//       setDuration(1);
//     } catch (e) {
//       alert(e.message);
//     }
//   };

//   const totalSales = entries.reduce((sum, e) => sum + Number(e.amount), 0);
//   const totalProfit = entries.reduce(
//     (sum, e) => sum + (Number(e.amount) - Number(e.expense || 0)),
//     0,
//   );

//   return (
//     <div
//       className={`min-h-screen ${isDark ? "bg-[#0b0f1a] text-slate-200" : "bg-slate-50 text-slate-900"} p-4 md:p-8 transition-colors`}
//     >
//       <div className="max-w-6xl mx-auto">
//         <div className="flex justify-between items-center mb-8">
//           <div className="flex items-center gap-3">
//             <div className="p-3 bg-blue-600 rounded-2xl shadow-lg shadow-blue-600/30">
//               <BrainCircuit className="text-white" />
//             </div>
//             <h1 className="text-xl font-black uppercase tracking-tighter">
//               Daily Sales Planner V.2 By Aung
//             </h1>
//           </div>
//           <div className="flex gap-2">
//             <button
//               onClick={exportToExcel}
//               className="p-2.5 bg-emerald-600/10 text-emerald-500 border border-emerald-500/20 rounded-xl hover:bg-emerald-600 hover:text-white transition-all"
//             >
//               <Download size={20} />
//             </button>
//             <button
//               onClick={() => sendTelegramMsg("🔔 Test Noti!")}
//               className="p-2.5 bg-blue-600/10 text-blue-500 border border-blue-500/20 rounded-xl transition-all"
//             >
//               <Send size={20} />
//             </button>
//             <button
//               onClick={() => setIsDark(!isDark)}
//               className={`p-2.5 rounded-xl border ${isDark ? "bg-slate-800 border-slate-700" : "bg-white shadow-sm"}`}
//             >
//               {isDark ? (
//                 <Sun size={20} className="text-yellow-400" />
//               ) : (
//                 <Moon size={20} />
//               )}
//             </button>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
//           <div
//             className={`p-6 rounded-3xl border text-center ${isDark ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200 shadow-sm"}`}
//           >
//             <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">
//               Total Sales
//             </p>
//             <h2 className="text-3xl font-black text-blue-500">
//               {totalSales.toLocaleString()}{" "}
//               <span className="text-xs opacity-50">Ks</span>
//             </h2>
//           </div>
//           <div
//             className={`p-6 rounded-3xl border text-center ${isDark ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200 shadow-sm"}`}
//           >
//             <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">
//               Net Profit
//             </p>
//             <h2
//               className={`text-3xl font-black ${totalProfit >= 0 ? "text-emerald-500" : "text-red-500"}`}
//             >
//               {totalProfit.toLocaleString()}{" "}
//               <span className="text-xs opacity-50">Ks</span>
//             </h2>
//           </div>
//         </div>

//         <div
//           className={`p-6 rounded-[2rem] mb-8 border ${isDark ? "bg-slate-900/30 border-slate-800" : "bg-white shadow-xl shadow-slate-200/50"}`}
//         >
//           <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold opacity-40 ml-1 uppercase">
//                 Sale Date
//               </label>
//               <input
//                 type="date"
//                 value={saleDate}
//                 onChange={(e) => setSaleDate(e.target.value)}
//                 className="w-full p-3 rounded-xl border border-slate-700 bg-transparent text-sm outline-none"
//               />
//             </div>
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold opacity-40 ml-1 uppercase">
//                 Customer
//               </label>
//               <input
//                 placeholder="Name"
//                 value={customerName}
//                 onChange={(e) => setCustomerName(e.target.value)}
//                 className="w-full p-3 rounded-xl border border-slate-700 bg-transparent text-sm outline-none"
//               />
//             </div>
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold opacity-40 ml-1 uppercase">
//                 Vpn Key
//               </label>
//               <input
//                 placeholder="Key Code"
//                 value={vpnKey}
//                 onChange={(e) => setVpnKey(e.target.value)}
//                 className="w-full p-3 rounded-xl border border-slate-700 bg-transparent text-sm outline-none font-mono"
//               />
//             </div>
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold text-purple-400 ml-1 uppercase tracking-tighter">
//                 Duration (Months)
//               </label>
//               <select
//                 value={duration}
//                 onChange={(e) => setDuration(Number(e.target.value))}
//                 className="w-full p-3 rounded-xl border border-slate-700 bg-slate-900 text-sm outline-none text-white cursor-pointer appearance-none"
//               >
//                 <option value={1}>1 Month (30 Days)</option>
//                 <option value={2}>2 Months (60 Days)</option>
//                 <option value={3}>3 Months (90 Days)</option>
//                 <option value={6}>6 Months (180 Days)</option>
//                 <option value={12}>1 Year (360 Days)</option>
//               </select>
//             </div>
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold text-blue-400 ml-1 uppercase">
//                 Price
//               </label>
//               <input
//                 type="number"
//                 value={amount}
//                 onChange={(e) => setAmount(e.target.value)}
//                 className="w-full p-3 rounded-xl border border-blue-500/30 bg-transparent text-sm font-bold text-blue-500"
//               />
//             </div>
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold text-red-400 ml-1 uppercase">
//                 Expense
//               </label>
//               <input
//                 type="number"
//                 value={expense}
//                 onChange={(e) => setExpense(e.target.value)}
//                 className="w-full p-3 rounded-xl border border-red-500/30 bg-transparent text-sm font-bold text-red-400"
//               />
//             </div>
//             <div className="space-y-1">
//               <label className="text-[10px] font-bold text-orange-400 ml-1 uppercase">
//                 Auto Expiry
//               </label>
//               <input
//                 type="date"
//                 value={expiryDate}
//                 readOnly
//                 className="w-full p-3 rounded-xl border border-orange-500/30 bg-transparent text-sm text-orange-400 font-bold opacity-80"
//               />
//             </div>
//             <div className="flex items-end">
//               <button
//                 onClick={handleSubmit}
//                 className="w-full py-3.5 bg-blue-600 hover:bg-blue-500 text-white font-black rounded-xl shadow-lg flex items-center justify-center gap-2 uppercase tracking-widest text-xs transition-all active:scale-[0.98]"
//               >
//                 {editId ? <Edit3 size={16} /> : <Plus size={16} />}{" "}
//                 {editId ? "Update" : "Save Record"}
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="space-y-3">
//           {entries.map((e) => {
//             const diff = Math.ceil(
//               (new Date(e.expiryDate) - new Date()) / (1000 * 60 * 60 * 24),
//             );
//             let statusStyle =
//               diff < 0
//                 ? "bg-red-500/10 text-red-500 border-red-500/20"
//                 : diff <= 3
//                   ? "bg-orange-500 text-white border-orange-600 animate-pulse"
//                   : "bg-emerald-500/10 text-emerald-500 border-emerald-500/20";

//             return (
//               <div
//                 key={e.id}
//                 className={`p-4 rounded-[1.5rem] border flex flex-wrap md:flex-nowrap justify-between items-center gap-4 transition-all duration-300 ${isDark ? "bg-slate-900/40 border-slate-800 hover:border-blue-500/50" : "bg-white border-slate-100 shadow-sm"}`}
//               >
//                 <div className="flex-1 min-w-[200px]">
//                   <div className="flex items-center gap-2 mb-1">
//                     <span
//                       className={`text-[9px] font-bold px-2 py-0.5 rounded-md ${isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500"}`}
//                     >
//                       {e.saleDate}
//                     </span>
//                     {e.duration > 1 && (
//                       <span className="text-[9px] font-black text-purple-400 bg-purple-400/10 px-2 py-0.5 rounded-md uppercase">
//                         {e.duration} Months
//                       </span>
//                     )}
//                   </div>
//                   <div className="font-bold text-lg text-blue-500 leading-tight">
//                     {e.customer}
//                   </div>
//                   <div className="text-[11px] opacity-40 font-mono mt-1 break-all">
//                     {e.key}
//                   </div>
//                 </div>

//                 <div className="flex flex-col items-center px-8 border-x border-slate-800/50 hidden md:flex">
//                   <span className="text-[9px] font-black opacity-30 tracking-widest uppercase mb-1">
//                     Profit
//                   </span>
//                   <span className="text-xl font-black text-emerald-500">
//                     {(e.amount - (e.expense || 0)).toLocaleString()}{" "}
//                     <span className="text-xs">Ks</span>
//                   </span>
//                 </div>

//                 <div className="flex flex-col items-end gap-1 ml-auto min-w-[120px]">
//                   <span
//                     className={`px-4 py-1 rounded-full text-[9px] font-black tracking-widest ${statusStyle}`}
//                   >
//                     {diff < 0 ? "EXPIRED" : diff <= 3 ? "ALERT" : "ACTIVE"}
//                   </span>
//                   <span className="text-[10px] font-bold opacity-40 flex items-center gap-1">
//                     {diff <= 3 && diff >= 0 && (
//                       <AlertTriangle size={12} className="text-orange-500" />
//                     )}{" "}
//                     {e.expiryDate}
//                   </span>
//                 </div>

//                 <div className="flex gap-1 md:ml-4 border-l border-slate-800/30 pl-3">
//                   <button
//                     onClick={() => {
//                       setEditId(e.id);
//                       setCustomerName(e.customer);
//                       setVpnKey(e.key);
//                       setAmount(e.amount);
//                       setExpense(e.expense);
//                       setDuration(e.duration || 1);
//                       setSaleDate(e.saleDate);
//                       window.scrollTo({ top: 0, behavior: "smooth" });
//                     }}
//                     className="p-2 text-slate-500 hover:text-blue-500 transition-all"
//                   >
//                     <Edit3 size={18} />
//                   </button>
//                   <button
//                     onClick={async () => {
//                       if (window.confirm("Sure?"))
//                         await deleteDoc(doc(db, "sales", e.id));
//                     }}
//                     className="p-2 text-slate-500 hover:text-red-400 transition-all"
//                   >
//                     <Trash2 size={18} />
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VPNTrackerApp;


import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  onSnapshot,
  query,
  orderBy,
  deleteDoc,
  doc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import {
  Plus,
  Trash2,
  Moon,
  Sun,
  Edit3,
  BrainCircuit,
  AlertTriangle,
  Send,
  Download,
} from "lucide-react";

const firebaseConfig = {
  apiKey: "AIzaSyBfZDqL3oynap-pKx-sicb_Fybhn-NIFlQ",
  authDomain: "dailyplanner-c0691.firebaseapp.com",
  projectId: "dailyplanner-c0691",
  storageBucket: "dailyplanner-c0691.firebasestorage.app",
  messagingSenderId: "942859622871",
  appId: "1:942859622871:web:276daf458d4ff7d0355392",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const TELEGRAM_BOT_TOKEN = "8685912259:AAElu44Uz8PHaQbrccqhsLB87dY4W0VlHQo";
const TELEGRAM_CHAT_ID = "5587626734";

const VPNTrackerApp = () => {
  const [entries, setEntries] = useState([]);
  const [isDark, setIsDark] = useState(true);

  const [customerName, setCustomerName] = useState("");
  const [vpnKey, setVpnKey] = useState("");
  const [amount, setAmount] = useState("");
  const [expense, setExpense] = useState("0");
  const [duration, setDuration] = useState(1);
  const [saleDate, setSaleDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [expiryDate, setExpiryDate] = useState("");
  const [editId, setEditId] = useState(null);

  const calculateExpiry = (dateString, months) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + months * 30);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    setExpiryDate(calculateExpiry(saleDate, duration));
  }, [saleDate, duration]);

  useEffect(() => {
    const q = query(collection(db, "sales"), orderBy("saleDate", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const rawData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));

      const sortedData = rawData.sort((a, b) => {
        if (a.saleDate === b.saleDate) {
          const timeA = a.createdAt?.toMillis() || 0;
          const timeB = b.createdAt?.toMillis() || 0;
          return timeB - timeA;
        }
        return 0;
      });

      setEntries([...sortedData]);
    });
    return () => unsubscribe();
  }, []);

  const sendTelegramMsg = async (text) => {
    const url = `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage?chat_id=${TELEGRAM_CHAT_ID}&text=${encodeURIComponent(text)}&parse_mode=HTML`;
    try {
      await fetch(url);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (entries.length === 0) return;

    entries.forEach(async (e) => {
      const diff = Math.ceil(
        (new Date(e.expiryDate) - new Date()) / (1000 * 60 * 60 * 24)
      );

      if (diff <= 3 && diff >= 0 && !e.alertSent) {
        try {
          await sendTelegramMsg(
            `⚠️ <b>Expiry Alert!</b>\n👤 Customer: ${e.customer}\n🔑 Key: ${e.key}\n⏳ Expires in: ${diff} days (${e.expiryDate})`
          );

          await updateDoc(doc(db, "sales", e.id), {
            alertSent: true
          });
        } catch (error) {
          console.error("Failed to send alert or update DB:", error);
        }
      }
    });
  }, [entries]);

  const exportToExcel = () => {
    if (entries.length === 0) return alert("ထုတ်ရန် Data မရှိပါ");
    const dataToExport = entries.map((e) => ({
      "Sale Date": e.saleDate,
      Customer: e.customer,
      "VPN Key": e.key,
      Duration: e.duration + " Months",
      Price: e.amount,
      Profit: Number(e.amount) - Number(e.expense || 0),
      Expiry: e.expiryDate,
    }));
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sales");
    XLSX.writeFile(wb, `VPN_Sales_Export.xlsx`);
  };

  const handleSubmit = async () => {
    if (!customerName || !amount) return alert("အချက်အလက် အပြည့်အစုံထည့်ပါ");
    const profit = Number(amount) - Number(expense);

    const data = {
      customer: customerName,
      key: vpnKey || "-",
      amount: Number(amount),
      expense: Number(expense),
      duration: duration,
      saleDate,
      expiryDate,
      updatedAt: Timestamp.now(),
      alertSent: false,
    };

    try {
      if (editId) {
        await updateDoc(doc(db, "sales", editId), data);
        setEditId(null);
      } else {
        await addDoc(collection(db, "sales"), {
          ...data,
          createdAt: Timestamp.now(),
        });
      }
      sendTelegramMsg(
        `<b>Success!</b>\n👤: ${customerName}\n💰 Profit: ${profit} Ks`,
      );
      setCustomerName("");
      setVpnKey("");
      setAmount("");
      setDuration(1);
    } catch (e) {
      alert(e.message);
    }
  };

  const totalSales = entries.reduce((sum, e) => sum + Number(e.amount), 0);
  const totalProfit = entries.reduce(
    (sum, e) => sum + (Number(e.amount) - Number(e.expense || 0)),
    0,
  );

  return (
    <div
      className={`min-h-screen ${isDark ? "bg-[#0b0f1a] text-slate-200" : "bg-slate-50 text-slate-900"} p-4 md:p-8 transition-colors`}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-blue-600 rounded-2xl shadow-lg shadow-blue-600/30">
              <BrainCircuit className="text-white" />
            </div>
            <h1 className="text-xl font-black uppercase tracking-tighter">
              Daily Sales Planner V.2 By Aung
            </h1>
          </div>
          <div className="flex gap-2">
            <button
              onClick={exportToExcel}
              className="p-2.5 bg-emerald-600/10 text-emerald-500 border border-emerald-500/20 rounded-xl hover:bg-emerald-600 hover:text-white transition-all"
            >
              <Download size={20} />
            </button>
            <button
              onClick={() => sendTelegramMsg("🔔 Test Noti!")}
              className="p-2.5 bg-blue-600/10 text-blue-500 border border-blue-500/20 rounded-xl transition-all"
            >
              <Send size={20} />
            </button>
            <button
              onClick={() => setIsDark(!isDark)}
              className={`p-2.5 rounded-xl border ${isDark ? "bg-slate-800 border-slate-700" : "bg-white shadow-sm"}`}
            >
              {isDark ? (
                <Sun size={20} className="text-yellow-400" />
              ) : (
                <Moon size={20} />
              )}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          <div
            className={`p-6 rounded-3xl border text-center ${isDark ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200 shadow-sm"}`}
          >
            <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">
              Total Sales
            </p>
            <h2 className="text-3xl font-black text-blue-500">
              {totalSales.toLocaleString()}{" "}
              <span className="text-xs opacity-50">Ks</span>
            </h2>
          </div>
          <div
            className={`p-6 rounded-3xl border text-center ${isDark ? "bg-slate-900/50 border-slate-800" : "bg-white border-slate-200 shadow-sm"}`}
          >
            <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">
              Net Profit
            </p>
            <h2
              className={`text-3xl font-black ${totalProfit >= 0 ? "text-emerald-500" : "text-red-500"}`}
            >
              {totalProfit.toLocaleString()}{" "}
              <span className="text-xs opacity-50">Ks</span>
            </h2>
          </div>
        </div>

        <div
          className={`p-6 rounded-[2rem] mb-8 border ${isDark ? "bg-slate-900/30 border-slate-800" : "bg-white shadow-xl shadow-slate-200/50"}`}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
            <div className="space-y-1">
              <label className="text-[10px] font-bold opacity-40 ml-1 uppercase">
                Sale Date
              </label>
              <input
                type="date"
                value={saleDate}
                onChange={(e) => setSaleDate(e.target.value)}
                className="w-full p-3 rounded-xl border border-slate-700 bg-transparent text-sm outline-none"
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold opacity-40 ml-1 uppercase">
                Customer
              </label>
              <input
                placeholder="Name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                className="w-full p-3 rounded-xl border border-slate-700 bg-transparent text-sm outline-none"
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold opacity-40 ml-1 uppercase">
                Vpn Key
              </label>
              <input
                placeholder="Key Code"
                value={vpnKey}
                onChange={(e) => setVpnKey(e.target.value)}
                className="w-full p-3 rounded-xl border border-slate-700 bg-transparent text-sm outline-none font-mono"
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-purple-400 ml-1 uppercase tracking-tighter">
                Duration (Months)
              </label>
              <select
                value={duration}
                onChange={(e) => setDuration(Number(e.target.value))}
                className="w-full p-3 rounded-xl border border-slate-700 bg-slate-900 text-sm outline-none text-white cursor-pointer appearance-none"
              >
                <option value={1}>1 Month (30 Days)</option>
                <option value={2}>2 Months (60 Days)</option>
                <option value={3}>3 Months (90 Days)</option>
                <option value={6}>6 Months (180 Days)</option>
                <option value={12}>1 Year (360 Days)</option>
              </select>
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-blue-400 ml-1 uppercase">
                Price
              </label>
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full p-3 rounded-xl border border-blue-500/30 bg-transparent text-sm font-bold text-blue-500"
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-red-400 ml-1 uppercase">
                Expense
              </label>
              <input
                type="number"
                value={expense}
                onChange={(e) => setExpense(e.target.value)}
                className="w-full p-3 rounded-xl border border-red-500/30 bg-transparent text-sm font-bold text-red-400"
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-bold text-orange-400 ml-1 uppercase">
                Auto Expiry
              </label>
              <input
                type="date"
                value={expiryDate}
                readOnly
                className="w-full p-3 rounded-xl border border-orange-500/30 bg-transparent text-sm text-orange-400 font-bold opacity-80"
              />
            </div>
            <div className="flex items-end">
              <button
                onClick={handleSubmit}
                className="w-full py-3.5 bg-blue-600 hover:bg-blue-500 text-white font-black rounded-xl shadow-lg flex items-center justify-center gap-2 uppercase tracking-widest text-xs transition-all active:scale-[0.98]"
              >
                {editId ? <Edit3 size={16} /> : <Plus size={16} />}{" "}
                {editId ? "Update" : "Save Record"}
              </button>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {entries.map((e) => {
            const diff = Math.ceil(
              (new Date(e.expiryDate) - new Date()) / (1000 * 60 * 60 * 24),
            );
            let statusStyle =
              diff < 0
                ? "bg-red-500/10 text-red-500 border-red-500/20"
                : diff <= 3
                  ? "bg-orange-500 text-white border-orange-600 animate-pulse"
                  : "bg-emerald-500/10 text-emerald-500 border-emerald-500/20";

            return (
              <div
                key={e.id}
                className={`p-4 rounded-[1.5rem] border flex flex-wrap md:flex-nowrap justify-between items-center gap-4 transition-all duration-300 ${isDark ? "bg-slate-900/40 border-slate-800 hover:border-blue-500/50" : "bg-white border-slate-100 shadow-sm"}`}
              >
                <div className="flex-1 min-w-[200px]">
                  <div className="flex items-center gap-2 mb-1">
                    <span
                      className={`text-[9px] font-bold px-2 py-0.5 rounded-md ${isDark ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500"}`}
                    >
                      {e.saleDate}
                    </span>
                    {e.duration > 1 && (
                      <span className="text-[9px] font-black text-purple-400 bg-purple-400/10 px-2 py-0.5 rounded-md uppercase">
                        {e.duration} Months
                      </span>
                    )}
                  </div>
                  <div className="font-bold text-lg text-blue-500 leading-tight">
                    {e.customer}
                  </div>
                  <div className="text-[11px] opacity-40 font-mono mt-1 break-all">
                    {e.key}
                  </div>
                </div>

                <div className="flex flex-col items-center px-8 border-x border-slate-800/50 hidden md:flex">
                  <span className="text-[9px] font-black opacity-30 tracking-widest uppercase mb-1">
                    Profit
                  </span>
                  <span className="text-xl font-black text-emerald-500">
                    {(e.amount - (e.expense || 0)).toLocaleString()}{" "}
                    <span className="text-xs">Ks</span>
                  </span>
                </div>

                <div className="flex flex-col items-end gap-1 ml-auto min-w-[120px]">
                  <span
                    className={`px-4 py-1 rounded-full text-[9px] font-black tracking-widest ${statusStyle}`}
                  >
                    {diff < 0 ? "EXPIRED" : diff <= 3 ? "ALERT" : "ACTIVE"}
                  </span>
                  <span className="text-[10px] font-bold opacity-40 flex items-center gap-1">
                    {diff <= 3 && diff >= 0 && (
                      <AlertTriangle size={12} className="text-orange-500" />
                    )}{" "}
                    {e.expiryDate}
                  </span>
                </div>

                <div className="flex gap-1 md:ml-4 border-l border-slate-800/30 pl-3">
                  <button
                    onClick={() => {
                      setEditId(e.id);
                      setCustomerName(e.customer);
                      setVpnKey(e.key);
                      setAmount(e.amount);
                      setExpense(e.expense);
                      setDuration(e.duration || 1);
                      setSaleDate(e.saleDate);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="p-2 text-slate-500 hover:text-blue-500 transition-all"
                  >
                    <Edit3 size={18} />
                  </button>
                  <button
                    onClick={async () => {
                      if (window.confirm("Sure?"))
                        await deleteDoc(doc(db, "sales", e.id));
                    }}
                    className="p-2 text-slate-500 hover:text-red-400 transition-all"
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VPNTrackerApp;